export const isDev = process.env.NODE_ENV === 'development'
export const isProd = process.env.NODE_ENV === 'production'
export const isDebug = Boolean(process.env.NEXT_PUBLIC_DEBUG)

export const isClient = typeof window !== 'undefined'
export const isServer = !isClient

export const siteURL = new URL(
  process.env.NEXTAUTH_URL ? process.env.NEXTAUTH_URL : 'http://localhost',
)
export const siteOrigin = siteURL.origin

export const DEFAULT_GRAPHQL_PAGE_SIZE = 10 // cf : https://github.com/naboo-team/naboo/blob/36b404c94cb4280fb578c5262bc5bdd10536c71d/packages/wome-api/src/common/dto/pagination.dto.ts#L14
